export const integrationUnconfiguredId = 'setup'

export const integrationStatuses = [
    'configured',
    'pending',
    'connected',
    'active',
    'authorization_failure'
]